module.exports = __webpack_public_path__ + "static/img/40011 (4).2bb297c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40011 (4).webp
// module id = 1ZMo
// module chunks = 14